<template>
  <BaseGridView
    endpoint="v1/JournalEntryVoucher/GetData"
    :pageTitle="$t('Journal Vouchers')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #customer_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge badge-success' : 'badge badge-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const templateDef: TemplateDef = {
  prefix: "customer",
  columnNames: ["isActive"],
};
const _searchOptions = {
  fields: [
    "company.Name",
    "createdDateTimeOffset",
    "lastChangedDateTimeOffset",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",

    },
    {
      field: "CreatedDateTimeOffset",
      headerText: instance?.$t("customerCreatedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    {
      field: "InApprovalWorkflow",
      headerText: instance?.$t("status"),
      template: "customer_isActive",
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
  ];
};
</script>
